<template>
	
		<Datatable :options="options" />
	
</template>

<script lang="ts">
import type Rider from '@/models/Rider'
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator'

@Component({
	components: {
		Datatable,
		Block,
	},
})
class TransactionTable extends Vue {
	@Prop({ type: Object })
	readonly rider!: Rider|null

	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []
		columns.push({
			data: 'id',
			orderable: true,
			name: 'id',
			title: 'Id',
		})
		columns.push({
			data: 'title',
			title: 'Title',
			orderable: true,
			name: 'title',
			render: CellRender.title(),
		})

		
		columns.push({
			data: 'agent.fullname',
			title: 'Agent',
		})
		columns.push({
			data: 'amount',
			title: 'Capital',
			render: CellRender.money(),
			name: 'amount',
			orderable: true,
		})

		columns.push({
			data: 'balance',
			title: 'Balance',
			render: CellRender.money(),
		})

		columns.push({
			data: 'created_at',
			title: 'Opened',
			name: 'created_at',
			render: CellRender.date(),
			orderable: true,
		})

		columns.push({
			data: 'yielded_at',
			title: 'Matured',
			render: CellRender.date(),
		})
		columns.push({
			data: 'completed_at',
			title: 'Closed',
			name: 'completed_at',
			render: CellRender.date(),
			orderable: true,
		})

		columns.push(Column.actions(this.$gate, { update: false }))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route(`rider.ajax.swap.saves`, { rider: this.rider.id  }),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
		}
	}
}

export default toNative(TransactionTable)
</script>
